"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteCustomRateMutation = exports.useFetchCustomRatesByOccupancyQuery = exports.useSaveCustomRatesMutation = exports.customRateApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.customRateApi = (0, react_1.createApi)({
    reducerPath: "customRateApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["customRates"],
    endpoints: function (builder) { return ({
        saveCustomRates: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/custom-rate/save",
                method: "POST",
                body: obj,
            }); },
            invalidatesTags: ["customRates"],
        }),
        fetchCustomRatesByOccupancy: builder.query({
            query: function (occupancyId) { return ({
                url: "/v1/custom-rate/by-occupancy",
                method: "GET",
                params: { occupancyId: occupancyId },
            }); },
            providesTags: ["customRates"],
        }),
        deleteCustomRate: builder.mutation({
            query: function (_a) {
                var rateId = _a.rateId;
                return ({
                    url: "/v1/custom-rate/remove?_id=".concat(rateId),
                    method: "DELETE",
                });
            },
            invalidatesTags: ["customRates"],
        }),
    }); },
});
exports.useSaveCustomRatesMutation = exports.customRateApi.useSaveCustomRatesMutation, exports.useFetchCustomRatesByOccupancyQuery = exports.customRateApi.useFetchCustomRatesByOccupancyQuery, exports.useDeleteCustomRateMutation = exports.customRateApi.useDeleteCustomRateMutation;
